export const OfferToCarryProduct = ({width = 15, height = 15}: {width?: number; height?: number}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
      <path
        fill="#000"
        d="M14.063 3.781v2.344a.938.938 0 0 1-.938.938h-2.139l-5.485 5.943a.469.469 0 0 1-.345.15H1.875a.937.937 0 0 1-.938-.937V9.875a.937.937 0 0 1 .938-.938h2.139l5.485-5.943a.469.469 0 0 1 .345-.15h3.281a.937.937 0 0 1 .938.937ZM12.05 9.075a.468.468 0 0 0-.663 0L9.981 10.48a.469.469 0 1 0 .663.663l.606-.606v2.15a.47.47 0 0 0 .938 0v-2.15l.605.606a.468.468 0 1 0 .664-.663L12.05 9.075Z"
      />
    </svg>
  );
};
